import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { SortOrder } from '@common/utils/search-sort';
import { AvailableTabsOnPage, LastPageStateWithTabs } from '@store/types/basic-last-page-state';

import { DriverItem } from '../../app/portal/pages/drivers/drivers.types';

export const driversAdapter = createEntityAdapter<DriverItem>({
  selectId: (item) => item.id as number,
});

export interface DriversState extends EntityState<DriverItem> {
  lastPageState: LastPageStateWithTabs;
  loading: boolean;
  error?: string;
}

export const initialDriversState: DriversState = driversAdapter.getInitialState({
  lastPageState: {
    activeTabOnPage: AvailableTabsOnPage.List,
    [AvailableTabsOnPage.List]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
    },
    [AvailableTabsOnPage.Groups]: {
      searchValue: '',
      sortOrder: SortOrder.Asc,
      openedGroupId: null,
      isOpenedFreeList: false,
    },
  },
  loading: false,
  error: undefined,
});
